import React from 'react';
import { makeStyles } from '@material-ui/core';
import MessageContent from '../MessageContent';

export default function WorkstationMessagesContent(props) {
    const classes = useStyles();

    return (
        <div className={classes.messagesContent}>
            <div className={classes.messages}>
                <div className={classes.title}>
                    Messages
            </div>
                <div className={classes.messagesContainer}>
                    {props.fakeDataWorkstation.messages.sort((a, b) => new Date(b.time) - new Date(a.time)).map(x => <MessageContent key={x.id} message={x} textWidth = {""} iconPadding = {"0px"} messageHeight = {"45px"} backgroundColor= {"#F4F4F4"}></MessageContent>)}
                </div>
            </div>
        </div>
    )

}

const useStyles = makeStyles(() => ({
    title: {
        fontSize: "15px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: '#8D8D8D',
        marginBottom: "10px"
    },
    messagesContainer: {
        display: "flex",
        flexDirection: "column",
        marginBottom: "25px",
     
    },  
    messagesContent:{
        backgroundColor:"white",
        padding:"20px",
        borderRadius:"5px",
    }
}));